import React from "react";
import { AutoComplete } from "components/inputs";

const ReferralReassignmentUneditableCodeSetField = ({
  label,
  ...other // passing ...other to AutoComplete to follow the pattern we use in other components
}) => (
  <AutoComplete
    label={label}
    disabled // make it uneditable
    {...other}
  />
);

export default ReferralReassignmentUneditableCodeSetField;
